// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__23fda","colCheckbox":"styles_colCheckbox__3i7aG"};